import { gql } from "@apollo/client";

import { SEARCH_SUGGESTIONS_FRAGMENT } from "constants/suggestions";

export const DELETE_POLICY = gql`
  mutation DeletePolicy($id: ID!, $force: Boolean) {
    policyDelete(id: $id, force: $force) {
      id
      name
    }
  }
`;

export const SEARCH_POLICIES = gql`
  query SearchPolicies($input: SearchInput!) {
    searchPolicies(input: $input) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          name
          type
          labels
          createdAt
          updatedAt
          body
          description
          plugin {
            id
            name
          }
          spaceDetails {
            id
            name
            accessLevel
          }
          hasAttachedStacks
        }
      }
    }
  }
`;

export const GET_POLICY_ATTACHMENTS = gql`
  query GetPolicyAttachments($id: ID!) {
    policy(id: $id) {
      id
      hasAttachedStacks
      attachedStacks {
        id
        stackId
        stackName
        isModule
      }
    }
  }
`;

export const SEARCH_POLICIES_SUGGESTIONS = gql`
  query SearchPoliciesSuggestions($input: SearchSuggestionsInput!) {
    searchPoliciesSuggestions(input: $input) {
      ...SearchSuggestionsFragment
    }
  }
  ${SEARCH_SUGGESTIONS_FRAGMENT}
`;
